import { setTokenManual } from "../services/jwtAuth";

// localStorage key holding the admin's original session while impersonating a user.
export const IMPERSONATOR_KEY = 'impersonator';

// Session keys written on login (see authSlice signIn) that identify the active user.
const SESSION_KEYS = ['auth_token', 'roles', 'user_id', 'camaba_id', 'registration_id', 'prodi_id', 'nama'];

const applySession = (session) => {
    SESSION_KEYS.forEach((key) => {
        const value = session[key];
        if (value === null || value === undefined) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }
    });
};

const snapshotSession = () => {
    const snapshot = {};
    SESSION_KEYS.forEach((key) => {
        snapshot[key] = localStorage.getItem(key);
    });
    return snapshot;
};

export const isImpersonating = () => !!localStorage.getItem(IMPERSONATOR_KEY);

export const getImpersonatorInfo = () => {
    const raw = localStorage.getItem(IMPERSONATOR_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
};

/**
 * Switch the active session to the impersonated user.
 * Stashes the current (admin) session so it can be restored later, writes the
 * impersonation response into localStorage exactly like a normal login, then
 * reloads so the whole app re-boots as the target user.
 *
 * @param {object} data the AuthenticationResponse from POST /v1/impersonate
 */
export const startImpersonation = (data) => {
    const admin = snapshotSession();
    admin.admin_nama = admin.nama;      // the admin's own name, for the banner
    admin.target_nama = data.nama;      // the impersonated user's name, for the banner
    localStorage.setItem(IMPERSONATOR_KEY, JSON.stringify(admin));

    applySession({
        auth_token: data.token && data.token.access_token,
        roles: data.roles,
        user_id: data.user_id,
        camaba_id: data.camaba_id,
        registration_id: data.registration_id,
        prodi_id: data.prodi_id,
        nama: data.nama,
    });
    setTokenManual(data.token && data.token.access_token);
    window.location.href = '/';
};

/**
 * Restore the admin's original session and return to the user management page.
 */
export const stopImpersonation = () => {
    const admin = getImpersonatorInfo();
    if (!admin) return;
    applySession(admin);
    localStorage.removeItem(IMPERSONATOR_KEY);
    setTokenManual(admin.auth_token);
    window.location.href = '/app/setting/akses-user';
};
